import { render, staticRenderFns } from "./NavigationLeft.vue?vue&type=template&id=4163bf22&scoped=true&"
import script from "./NavigationLeft.vue?vue&type=script&lang=js&"
export * from "./NavigationLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4163bf22",
  null
  
)

export default component.exports